import {Link as RoutedLink} from 'react-router-dom';

import {ExternalLinkIcon} from 'shells/icon';
import {Link} from 'shells/link/link';
import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';
import {Body} from 'shells/typography/body';

interface Props {
    isVerified: boolean;
    lastVerifiedTime: number | null;
}

export function ForwardingStatusPopoverContent(props: Props) {
    const body =
        props.isVerified && props.lastVerifiedTime ? (
            <>
                Last verified{' '}
                <FormattedTimestamp
                    className='inline-block'
                    datetime={props.lastVerifiedTime}
                    format={FormattedTimestamp.formats.longDayMonth}
                />
                .
            </>
        ) : (
            'Visit inbox settings to set up forwarding.'
        );

    return (
        <div className='flex flex-dir-col justify-center pad-24 align-center gap-16'>
            <Body>{body}</Body>
            <Link
                // @ts-expect-error
                as={RoutedLink}
                to='/inbox/settings/email'
                icon={ExternalLinkIcon}
                variant='primary'
                size='small'
            >
                Inbox settings
            </Link>
        </div>
    );
}
